export default "__VITE_PUBLIC_ASSET__8ba9cef4__"